import { AppDynamicsService } from './../../shared/services/app-dynamics.service';
import { Component, OnInit, ElementRef, Renderer2, HostListener } from '@angular/core';
import { GlobalProperties } from '../../shared/global-properties';
import { AnalyticsService } from '../../shared/services/analytics.service';
import { Ga4Service } from '../../shared/services/ga4.service';

@Component({
  selector: 'card-confirmation',
  templateUrl: './card-confirmation.component.html',
  styleUrls: ['./card-confirmation.component.css']
})
export class CardConfirmationComponent extends GlobalProperties {

  img: string;

  readonly PAGE_NAME = {
    section: 'NovoCartao',
    page: 'CartaoLiberado'
  };

  constructor(
    private analyticsService: AnalyticsService,
    private ga4Service: Ga4Service,
    private elementRef: ElementRef,
    private appDynamicsService: AppDynamicsService,
  ) {
    super();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // 29/06/2020 - Thomas - Conforme Andrea (Itau) a ilustração dos bonequinhos
    // são antigas, devendo todas ficar com o modelo novo
    // if (window.innerWidth > 640) {
    //   this.img = 'ilustra_cartao_liberado.svg';
    // } else {
    //   this.img = '12_cartao_liberado.svg';
    // }
  }

  ngOnInit() {
    this.analyticsService.trackPageLoad(this.PAGE_NAME);
    this.ga4Service.trackPageLoad(this.PAGE_NAME);
    this.appDynamicsService.callAppAdynamics(this.elementRef);

    // if (window.innerWidth > 640) {
    //   this.img = 'ilustra_cartao_liberado.svg';
    // } else {
    //   this.img = '12_cartao_liberado.svg';
    // }

    this.img = '12_cartao_liberado.svg';
  }

}
